import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, Paper, TextField, Typography } from '@material-ui/core';
import { Info, Send } from '@material-ui/icons';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Title } from 'react-admin';
import dataProvider from '../../providers/data-provider';

const useStyles = makeStyles((theme) => ({

    main: {
        backgroundColor: '#1e1e1e',
        paddingTop: '16px',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingBottom: '8px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column'
    },

    chatArea: {
        display: 'flex',
        flexDirection: 'column',
        height: '450px',
        overflow: 'scroll',
        marginTop: '1rem',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',

        '&::-webkit-scrollbar': {
            display: 'none'
        },

        '&:-webkit-scrollbar': {
            display: 'none'
        },

    },

    'chatArea::-webkit-scrollbar': {
        display: 'none'
    },

    messageArea: {
        display: 'flex',
    },

    textField: {
        flexGrow: 1,
        marginRight: '8px',
    },

    userMessage: {
        paddingTop: '4px',
        paddingBottom: '4px',
        paddingLeft: '8px',
        paddingRight: '8px',
        backgroundColor: '#3dad24',
        borderRadius: '8px',
        color: theme.textPrimary,
        marginTop: '8px',
        marginBottom: '8px',
        marginRight: '16px',
        width: '60%',
        alignSelf: 'flex-end'
    },
    aiMessage: {
        paddingTop: '4px',
        paddingBottom: '4px',
        paddingLeft: '8px',
        paddingRight: '8px',
        backgroundColor: '#2452ad',
        borderRadius: '8px',
        color: theme.textPrimary,
        marginTop: '8px',
        marginBottom: '8px',
        marginLeft: '16px',
        width: '60%',
        alignSelf: 'flex-start'

    },
    arrow: {
        width: '16px',
        height: '16px',
        background: '#3dad24',
        position: 'relative',
        left: '99%',
        top: '-4px',
        transform: 'skewX(-45deg)',
    },
    arrowAi: {
        width: '16px',
        height: '16px',
        backgroundColor: '#2452ad',
        position: 'relative',
        left: '-1.5%',
        top: '-4px',
        transform: 'skewX(45deg)',
    },

}))

const MessageList = ({ messages, ...props }) => {
    const messageBottom = useRef(null)
    const scrollToBottom = () => {
        messageBottom.current?.scrollIntoView({ behavior: 'smooth' })
    }
    useEffect(scrollToBottom, [messages])
    const styles = useStyles()
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {
                messages && messages.map((msg) => (
                    msg.role === 'system' ?
                        <div className={styles.aiMessage}>
                            <div className={styles.arrowAi} />
                            <CircularProgress style={{ margin: 'auto' }} />
                        </div>
                        :
                        <div className={msg.role === 'user' ? styles.userMessage : styles.aiMessage}>
                            <div className={msg.role === 'user' ? styles.arrow : styles.arrowAi} />
                            {msg.content.split('\n').map(part => <Typography>{part}</Typography>)}
                            <div style={{ textAlign: 'right' }}>{msg.timestamp}</div>
                        </div>
                ))
            }
            <div ref={messageBottom} />
        </div>
    )
}

export const JuristtaChatGPTPage = (props) => {

    const [waiting, setWaiting] = useState(false);
    const [messages, setMessages] = useState([]);
    const [prompt, setPrompt] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);

    const sendPrompt = () => {
        setMessages(m => [...m, { role: 'user', content: prompt, timestamp: new Date().toLocaleString('pt-BR') }])
        setPrompt('')
        setWaiting(true)
        setMessages(m => [...m, { role: 'system', content: 'waiting' }])
        getReponse()
    }

    const getReponse = async () => {
        const response = await dataProvider.sendPromptToAI(prompt, messages)
        setMessages(m => [...m.slice(0, m.length - 1), { ...response, timestamp: new Date().toLocaleString('pt-BR') }])
        setWaiting(false)
    }

    const onDialogOpen = () => {
        setDialogOpen(true)
    }

    const onDialogClose = () => {
        setDialogOpen(false)
    }

    const handleTextField = useCallback(event => {
        setPrompt(event.target.value)
    }, [])

    const keyPress = (event) => {
        if (!waiting && event.keyCode === 13 && prompt.length > 0) {
            sendPrompt()
        }
    }

    const styles = useStyles();

    return (
        <>
            <Title title={'Chat-GPT'} />
            <Paper className={styles.main}>
                <Grid item>
                    <Button startIcon={<Info />} onClick={onDialogOpen}>
                        <Typography>Informações</Typography>
                    </Button>
                    <Dialog open={dialogOpen} onClose={onDialogClose}>
                        <DialogTitle>
                            Informações
                        </DialogTitle>
                        <DialogContent>
                            <Typography> A integração ChatGPT/Juristta está em fase inicial e depende de recursos externos da OpenAI. </Typography>
                            <Typography> Por favor, tenha em mente que, embora a ferramenta de IA possa ajudá-lo a gerar textos, o conteúdo gerado por ela não reflete necessariamente as visões ou opiniões da empresa. </Typography>
                            <Typography>É importante usar o material com cautela e sempre revisá-lo para garantir que esteja correto e completo antes de usá-lo.  </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' color='primary' onClick={onDialogClose}>OK</Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
                <Grid item className={styles.chatArea}>
                    <MessageList messages={messages} />
                </Grid>
                <Grid item className={styles.messageArea}>
                    <TextField placeholder='Insira seu texto aqui' onKeyDown={keyPress} value={prompt} className={styles.textField} onChange={handleTextField} />
                    <Button endIcon={<Send />} variant={'contained'} color={'primary'} onClick={sendPrompt} disabled={waiting || (!waiting && prompt.length === 0)}> Enviar </Button>
                </Grid>
            </Paper>
        </>
    )
}